import sortBy from 'lodash/sortBy';

// Converts the <AutoComplete /> value Array into Gui-def coma separated string "tag1, tag2, tag3"
export const createStringValueFromArray = (
  values: { value: string | number; label: string }[] = []
) => {
  return values.map(({ label }) => label).join(', ');
};

export const searchTags = async (search: string) => {
  const response = await fetch(
    `/API/V3/Account/${window.merchantos.account.id}/Tag.json?name=~,${search}%&limit=50&sort=name`
  );

  let apiTags: TagFromAPI[] = [];
  let tags: AutocompleteOption[] = [];
  try {
    ({ Tag: apiTags } = await response.json());

    if (apiTags && !(apiTags instanceof Array)) {
      apiTags = [apiTags];
    }

    tags = sortBy(
      apiTags.map(({ name }) => ({ value: name, label: name })),
      ['label']
    );
  } catch (err) {
    // Error parsing the API response
  }

  return tags;
};
